// external dependencies
import React from 'react'
import styled from '@emotion/styled'

// constants
import { COLORS, FONT_SIZES, MQ } from 'utils/styleHelpers'

// Text above partner logos
const H3 = styled.h3`
	color: ${COLORS.BLACK_TEXT};
	font-size: ${FONT_SIZES.H4};
	line-height: ${FONT_SIZES.H4};
	margin: 0 auto;
	padding: 20px 0;
	text-align: center;
	width: 80%;
`

const Paragraph = styled.p`
	font-size: ${FONT_SIZES.H4};
	line-height: ${FONT_SIZES.H4};
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin: 0 auto;
	width: 70%;

	${MQ.S} {
		justify-content: space-around;
		width: 60%;
	}

	${MQ.M} {
		justify-content: space-around;
		width: 100%;
	}
`

const Strong = styled.strong`
	font-weight: bold;
`

export default {
	h3: props => <H3 {...props} />,
	p: props => <Paragraph {...props} />,
	strong: props => <Strong {...props} />,
}
